import { ButtonWrap } from "@hopper-b2b/ui";
import clsx from "clsx";
import Chevron from "../../assets/client/arrow-back.svg?react";
import Close from "../../assets/client/close.svg?react";
import styles from "./styles.module.scss";

export interface GenericHeaderProps {
  title: string;
  onBack: () => void;
  close?: boolean;
}

export function GenericHeader({
  title,
  onBack,
  close = false,
}: GenericHeaderProps) {
  return (
    <div className={clsx(styles.GenericHeader, "GenericHeader")}>
      <ButtonWrap className={styles.GenericHeaderBack} onClick={onBack}>
        {close ? <Close /> : <Chevron />}
      </ButtonWrap>
      <h2 className={styles.GenericHeaderTitle}>{title}</h2>
    </div>
  );
}
